'use client';

import { ReactNode } from 'react';
// TODO move LayoutDefault component here, without of 'use client'
import { LayoutDefault as LayoutDefaultComponent } from '@components/layout/Layouts/LayoutDefault';

export default function LayoutDefault({ children }: { children: ReactNode }) {
  return (
    <LayoutDefaultComponent hideFooter>
      {children}
    </LayoutDefaultComponent>
  );
}
